import { $k18n } from '@/common/i18n';
import { ISelfBuildCoupon } from '@/page/orderDetail/view/apis';

/**
 * 运费券title文案
 */
export const getCouponTitleForFeeType3 = (couponInfo, shippingCouponTextAB) => {
    if (shippingCouponTextAB) {
        // 运费券最高减少运费 不同后端给的字段名不同 产品着急上线 暂时做个兼容
        if (couponInfo?.deductionAmount > 0 && couponInfo?.displayDeductionAmount) {
            return $k18n({ id: 'k_1225781', params: { num: couponInfo?.displayDeductionAmount } });
        }
        if (couponInfo?.maxDeductAmount > 0 && couponInfo?.displayMaxDeductAmount) {
            return $k18n({ id: 'k_1225781', params: { num: couponInfo?.displayMaxDeductAmount } });
        }
        if (couponInfo?.maxDeductAmount?.amount > 0 && couponInfo?.maxDeductAmount?.displayAmount) {
            return $k18n({ id: 'k_1225781', params: { num: couponInfo?.maxDeductAmount?.displayAmount } });
        }
    }

    return $k18n({ id: 'free_shipping_upper', text: '包邮' });
};

// 获取优惠券优惠文案
// 运费券：包邮、满减券：R$10 OFF、折扣券：10% OFF
export const getCouponDiscount = (
    coupon: ISelfBuildCoupon,
    opt?: {
        showDiscountCouponAmount?: boolean;
        shippingCouponTextAB?: boolean;
        lineOptimizeAB?: boolean; // 文案优化ab
    }
) => {
    /**
     * @todo 通过abtest替换文案
     */
    // 折扣券展示实际抵扣额，非百分比
    const showDiscountCouponAmount = opt?.showDiscountCouponAmount ?? false;

    // 运费券
    if (coupon.discountFeeType === 3) {
        return getCouponTitleForFeeType3(coupon, opt?.shippingCouponTextAB);
    }

    // 折扣券
    if (coupon.discountFeeType === 2 && coupon.discountType === 3) {
        if (showDiscountCouponAmount) {
            return opt?.lineOptimizeAB
                ? $k18n({ text: '${0} Off', id: 'k_1309357', params: { 0: coupon.displayDeductionAmount } })
                : $k18n({ text: '{discount} OFF', id: 'k_322805', params: { discount: coupon.displayDeductionAmount } });
        } else {
            return $k18n({ text: '{0}% off', id: 'k_1221298', params: { 0: coupon.displayDiscountPercent } });
        }
    }

    return opt?.lineOptimizeAB
        ? $k18n({ text: '${0} Off', id: 'k_1309357', params: { 0: coupon.displayDeductionAmount } })
        : $k18n({ text: '{discount} OFF', id: 'k_322805', params: { discount: coupon.displayDeductionAmount } });
};

// 获取优惠券类型文案
// 商品、运费
export const getCouponType = (coupon: ISelfBuildCoupon) => {
    if (coupon.discountFeeType === 3) {
        return $k18n({ id: 'k_322802', text: '运费' });
    }

    if (coupon.discountFeeType === 2) {
        return $k18n({ id: 'product_coupon_tag', text: '商品' });
    }

    return $k18n({ id: 'k_322802', text: '运费' });
};

// 优惠券适用范围文案
export const getCouponRange = (coupon: ISelfBuildCoupon) => {
    if (coupon.firstOrderLimit) {
        return $k18n({ id: 'k_445500', text: '首单可用' });
    }

    const discountRangeTypeMapText = {
        0: $k18n({ id: 'k_342784', text: '大部分商品可用' }),
        1: $k18n({ id: 'k_435825', text: '指定商品可用' }),
        2: $k18n({ id: 'k_342785', text: '指定店铺可用' }),
        3: $k18n({ id: 'k_342786', text: '指定商品品类可用' }),
    };

    return discountRangeTypeMapText[coupon.discountRangeType] || $k18n({ id: 'k_342784', text: '大部分商品可用' });
};

// 优惠券最大减免金额
export const getCouponMaxDeductAmount = (coupon: ISelfBuildCoupon) => {
    if (coupon.discountFeeType === 2 && coupon.discountType === 3) {
        return $k18n({
            id: 'k_1221299',
            text: '最高优惠{0}雷',
            params: { 0: coupon.displayMaxDeductAmount },
        });
    }

    return $k18n({
        id: 'max_discount',
        text: 'Capped at {max_discount}',
        params: { max_discount: coupon.displayMaxDeductAmount },
    });
};

// 优惠券门槛
export const getCouponThreshold = (coupon: ISelfBuildCoupon) => {
    if (typeof coupon?.threshold === 'number' && coupon?.threshold !== 0) {
        return $k18n({ id: 'k_322825', params: { min_spend: coupon.displayThreshold } });
    }

    if (coupon?.threshold && typeof coupon?.threshold === 'object' && (coupon?.threshold as any)?.amount) {
        return $k18n({ id: 'k_322825', params: { min_spend: (coupon?.threshold as any)?.displayAmount } });
    }

    return $k18n({ id: 'k_322811', text: '无门槛' });
};
